export default __webpack_public_path__ + "static/media/community-support-img.60afe07f.png";